/* JANUS theme — menu, cart drawer, product form, gallery, variant picker */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var scrim = document.createElement('div');
  scrim.className = 'scrim';
  document.body.appendChild(scrim);
  var lastFocus = null;

  function openPanel(el, trigger) {
    lastFocus = trigger || document.activeElement;
    el.classList.add('is-open');
    scrim.classList.add('is-visible');
    document.documentElement.style.overflow = 'hidden';
    var focusable = el.querySelector('button, a, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closePanels() {
    document.querySelectorAll('.is-open[data-panel]').forEach(function (el) { el.classList.remove('is-open'); });
    document.querySelectorAll('[data-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    scrim.classList.remove('is-visible');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  scrim.addEventListener('click', closePanels);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });

  /* The phone menu lives at the top level of the page, outside the sticky header, so nothing can layer over it */
  function hoistMenu() {
    document.querySelectorAll('[data-menu]').forEach(function (m) {
      if (m.parentElement === document.body) return;
      document.querySelectorAll('body > [data-menu]').forEach(function (old) { old.remove(); }); // theme editor re-render
      document.body.appendChild(m);
    });
  }
  hoistMenu();
  document.addEventListener('shopify:section:load', function () { hoistMenu(); measureAnnouncement(); });

  /* Let the announcement bar scroll away while the header itself stays stuck */
  function measureAnnouncement() {
    var a = document.querySelector('.section-header .announcement');
    document.documentElement.style.setProperty('--announce-h', (a ? a.offsetHeight : 0) + 'px');
  }
  measureAnnouncement();
  window.addEventListener('resize', measureAnnouncement);

  /* Mobile menu */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (!t) return;
    var nav = document.querySelector('[data-menu]');
    if (!nav) return;
    t.setAttribute('aria-expanded', 'true');
    openPanel(nav, t);
  });
  document.addEventListener('click', function (e) { if (e.target.closest('[data-panel-close]')) { e.preventDefault(); closePanels(); } });

  /* Cart drawer */
  function drawer() { return document.querySelector('[data-cart-drawer]'); }
  function openCart(trigger) { var d = drawer(); if (d) openPanel(d, trigger); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open]');
    if (!t || !drawer()) return;
    e.preventDefault();
    // tapped BASKET inside the phone menu: swap the menu for the basket
    document.querySelectorAll('.is-open[data-menu]').forEach(function (m) { m.classList.remove('is-open'); });
    openCart(t);
  });

  function renderCart(sectionsHtml) {
    var html = sectionsHtml && sectionsHtml['cart-drawer'];
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-inner]');
    var current = document.querySelector('[data-cart-drawer] [data-cart-inner]');
    if (fresh && current) current.replaceWith(fresh);
    var count = fresh ? fresh.getAttribute('data-count') : null;
    if (count !== null) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.setAttribute('data-count', count);
      });
    }
  }

  function cartRequest(url, body) {
    var d = drawer();
    if (d) d.classList.add('is-loading');
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Something went wrong');
        return data;
      });
    }).then(function (data) {
      renderCart(data.sections);
      return data;
    }).finally(function () { if (d) d.classList.remove('is-loading'); });
  }

  /* Quantity change / remove inside drawer and cart page */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-qty]');
    if (!b) return;
    e.preventDefault();
    var line = parseInt(b.getAttribute('data-line'), 10);
    var qty = parseInt(b.getAttribute('data-line-qty'), 10);
    var onCartPage = b.closest('[data-cart-page]');
    cartRequest('cart/change.js', { line: line, quantity: Math.max(0, qty) }).then(function () {
      if (onCartPage) window.location.reload();
    }).catch(function (err) { alert(err.message); });
  });

  /* Add to basket */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || !drawer()) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var err = form.querySelector('[data-form-error]');
    if (err) err.textContent = '';
    if (btn) btn.setAttribute('aria-busy', 'true');
    var fd = new FormData(form);
    cartRequest('cart/add.js', {
      items: [{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) }]
    }).then(function () { openCart(btn); })
      .catch(function (x) { if (err) err.textContent = x.message; })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  /* Quantity steppers on product page */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value || '1', 10) + parseInt(b.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, Math.min(99, v));
  });

  /* Product gallery: a native swipe track (scroll-snap), thumbnails, arrows and a full-screen viewer */
  function slides(gallery) { return gallery ? gallery.querySelectorAll('[data-media]') : []; }
  function goTo(gallery, index, instant) {
    var track = gallery && gallery.querySelector('[data-track]');
    var all = slides(gallery);
    if (!track || !all.length) return;
    index = Math.max(0, Math.min(all.length - 1, index));
    // 'instant' (not 'auto') so the stylesheet's smooth scrolling doesn't turn a jump into a slow glide
    track.scrollTo({ left: index * track.clientWidth, behavior: instant ? 'instant' : 'smooth' });
    if (instant) markCurrent(gallery, index);
  }
  function markCurrent(gallery, index) {
    var all = slides(gallery);
    all.forEach(function (m, i) { m.classList.toggle('is-active', i === index); });
    gallery.querySelectorAll('[data-thumb]').forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    var counter = gallery.querySelector('[data-counter]');
    if (counter) counter.textContent = (index + 1) + ' / ' + all.length;
    var prev = gallery.querySelector('[data-step="-1"]'), next = gallery.querySelector('[data-step="1"]');
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index === all.length - 1;
    gallery._index = index;
  }
  function showMedia(gallery, id) {
    var all = slides(gallery);
    for (var i = 0; i < all.length; i++) if (all[i].getAttribute('data-media') === String(id)) { goTo(gallery, i); return; }
  }
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-track]');
    if (!track) return;
    var start = 0;
    slides(gallery).forEach(function (m, i) { if (m.classList.contains('is-active')) start = i; });
    markCurrent(gallery, start);
    if (start) requestAnimationFrame(function () { goTo(gallery, start, true); });
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== gallery._index) markCurrent(gallery, i);
      });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(gallery, gallery._index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(gallery, gallery._index - 1); }
    });
    gallery.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]');
      if (t) { showMedia(gallery, t.getAttribute('data-thumb')); return; }
      var s = e.target.closest('[data-step]');
      if (s) { goTo(gallery, gallery._index + parseInt(s.getAttribute('data-step'), 10)); return; }
      if (e.target.closest('[data-zoom-current]')) { openViewer(gallery, gallery._index || 0, e.target.closest('[data-zoom-current]')); return; }
      var z = e.target.closest('[data-zoom]');
      if (z) openViewer(gallery, parseInt(z.getAttribute('data-zoom'), 10), z);
    });
    window.addEventListener('resize', function () { goTo(gallery, gallery._index, true); });
  });

  /* Full-screen viewer: swipe (or arrow keys) through every image at full size */
  var viewer = null;
  function openViewer(gallery, index, trigger) {
    var data = gallery.querySelector('[data-lightbox-images]');
    var imgs = [];
    try { imgs = JSON.parse(data.textContent); } catch (err) { return; }
    if (!imgs.length) return;
    viewer = document.createElement('div');
    viewer.className = 'viewer';
    viewer.setAttribute('role', 'dialog');
    viewer.setAttribute('aria-modal', 'true');
    viewer.setAttribute('aria-label', 'Product images, full size');
    viewer.innerHTML =
      '<div class="viewer__bar"><span class="viewer__count" data-viewer-count></span>' +
      '<button type="button" class="viewer__close" data-viewer-close aria-label="Close">CLOSE &#10005;</button></div>' +
      '<div class="viewer__track" data-viewer-track tabindex="-1">' +
      imgs.map(function (im, i) { return '<figure class="viewer__slide"><img src="' + im.src + '" alt="' + String(im.alt).replace(/"/g, '&quot;') + '"' + (Math.abs(i - index) > 1 ? ' loading="lazy"' : '') + '></figure>'; }).join('') +
      '</div>' +
      (imgs.length > 1 ? '<button type="button" class="viewer__arrow viewer__arrow--prev" data-viewer-step="-1" aria-label="Previous image">&#9664;&#9664;</button><button type="button" class="viewer__arrow viewer__arrow--next" data-viewer-step="1" aria-label="Next image">&#9654;&#9654;</button>' : '');
    document.body.appendChild(viewer);
    document.documentElement.style.overflow = 'hidden';
    var vtrack = viewer.querySelector('[data-viewer-track]');
    var count = viewer.querySelector('[data-viewer-count]');
    var current = index;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var paint = function () { count.textContent = 'PLAY ▶ ' + pad(current + 1) + ' / ' + pad(imgs.length); };
    var step = function (d) { vtrack.scrollTo({ left: (current + d) * vtrack.clientWidth, behavior: 'smooth' }); };
    vtrack.scrollTo({ left: index * vtrack.clientWidth, behavior: 'instant' }); paint();
    vtrack.addEventListener('scroll', function () {
      var i = Math.round(vtrack.scrollLeft / Math.max(1, vtrack.clientWidth));
      if (i !== current) { current = i; paint(); }
    }, { passive: true });
    var close = function () {
      if (!viewer) return;
      document.removeEventListener('keydown', keys);
      var v = viewer; viewer = null;
      v.classList.add('is-closing');
      setTimeout(function () { v.remove(); }, 260);
      document.documentElement.style.overflow = '';
      goTo(gallery, current, true);
      // hand focus back to the image now showing, without letting the browser scroll the gallery to it
      var back = slides(gallery)[current];
      back = (back && back.querySelector('[data-zoom]')) || trigger;
      if (back && back.focus) back.focus({ preventScroll: true });
    };
    var keys = function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'Tab') { e.preventDefault(); viewer.querySelector('[data-viewer-close]').focus(); }
    };
    document.addEventListener('keydown', keys);
    viewer.addEventListener('click', function (e) {
      if (e.target.closest('[data-viewer-close]')) return close();
      var s = e.target.closest('[data-viewer-step]');
      if (s) return step(parseInt(s.getAttribute('data-viewer-step'), 10));
      // a tap on the dark space around an image closes it
      if (e.target.classList.contains('viewer__slide')) close();
    });
    viewer.querySelector('[data-viewer-close]').focus();
  }

  /* Variant picker */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var section = picker.closest('[data-product-section]');
    var json = section.querySelector('[data-product-json]');
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var money = section.getAttribute('data-money-format') || '£{{amount}}';

    function fmt(cents) {
      var amount = (cents / 100).toFixed(2);
      return money.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount.replace(/\.00$/, ''));
    }
    function selected() {
      return Array.prototype.map.call(picker.querySelectorAll('[data-option]'), function (group) {
        var on = group.querySelector('[aria-pressed="true"]');
        return on ? on.getAttribute('data-value') : null;
      });
    }
    function update() {
      var opts = selected();
      var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      var idInput = section.querySelector('[data-variant-id]');
      var btn = section.querySelector('[data-add-button]');
      var label = section.querySelector('[data-add-label]');
      var price = section.querySelector('[data-price]');
      if (!v) {
        if (btn) btn.disabled = true;
        if (label) label.textContent = 'UNAVAILABLE';
        return;
      }
      idInput.value = v.id;
      if (btn) btn.disabled = !v.available;
      if (label) label.textContent = v.available ? 'ADD TO BASKET' : 'SOLD OUT';
      if (price) price.innerHTML = (v.compare_at_price > v.price ? '<s>' + fmt(v.compare_at_price) + '</s>' : '') + fmt(v.price);
      if (v.featured_media) showMedia(section.querySelector('[data-gallery]'), v.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    picker.addEventListener('click', function (e) {
      var b = e.target.closest('[data-value]');
      if (!b) return;
      b.closest('[data-option]').querySelectorAll('[data-value]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      update();
    });
  });
})();
